import { BoundPopup } from "lib/@components/combos/boundPopup"
import { useSkills } from "routes/@lib/skills"

export function AuthoringEditSkills({ onClick, children }) {
    const [skillSets] = useSkills()

    return (
        <>
            {!!skillSets && (
                <BoundPopup
                    field="skillSet"
                    label="Skill"
                    options={Object.fromEntries(
                        Object.values(skillSets ?? {})
                            .filter(ensureValidInteger)
                            .map(({ CoreSkillingID, SkillingCode, Skilling }) => [
                                CoreSkillingID,
                                `${SkillingCode}: ${Skilling}`,
                            ])
                    )}
                    onClick={onClick}
                    data-cy="edit-skills"
                >
                    {children}
                </BoundPopup>
            )}
        </>
    )
}

function ensureValidInteger({ CoreSkillingID }) {
    const skillNum = Number(CoreSkillingID)
    return Number.isFinite(skillNum) && Number.isInteger(skillNum)
}
